const course1Menu = [
  {
    "label": "manager",
    "key": "manager",
    "role": "manager",
    "icon": "pi pi-briefcase",
    "items":
      [
        {"label": "agreement", "url": "/manager/agreements", "icon": "pi pi-file-edit"},
        {"label": "club_info", "url": "/manager/company/info", "icon": "pi pi-globe"},
        {"label": "club_members", "url": "/manager/member/list", "icon": "pi pi-users"},
        {"label": "teams", "url": "/manager/team/list", "icon": "pi pi-prime"},
        {"label": "lessons", "url": "/manager/trainings/list", "icon": "pi pi-book"},
        {"label": "attendance", "url": "/manager/trainings/attendance", "icon": "pi pi-chart-line"},
        {"label": "billing", "url": "/manager/billing/info", "icon": "pi pi-dollar"}
      ]
  },
  {
    "label": "trainer",
    "key": "trainer",
    "role": "trainer",
    "icon": "pi pi-flag-fill",
    "items": [
      {"label": "teams","url": "/trainer/team/list","icon": "pi pi-prime"},
      {"label": "attendance","url": "/trainer/trainings", "icon": "pi pi-chart-line"},
      {"label": "team_members","url": "/trainer/members", "icon": "pi pi-users"}
    ]
  },
  {
    "label": "parent",
    "key": "parent",
    "role": "parent",
    "icon": "pi pi-heart-fill",
    "items":
      [
        {"label": "my_children", "url": "/parent/children/list", "icon": "pi pi-users"},
        {"label": "attendance", "url": "/parent/children/attendance", "icon": "pi pi-chart-line"},
        {"label": "billing", "url": "/parent/children/billing", "icon": "pi pi-dollar"}
      ]
  },
  {
    "label": "member",
    "key": "member",
    "role": "member",
    "icon": "pi pi-user",
    "items":
      [
        {"label": "about_me", "url": "/member/about", "icon": "pi pi-briefcase"},
        {"label": "attendance", "url": "/member/attendance", "icon": "pi pi-chart-line"},
        {"label": "billing", "url": "/member/billing", "icon": "pi pi-dollar"},
      ]
  },
  {
    "label": "Course #1",
    "key": "anonymous",
    "role": "anonymous",
    "icon": "pi pi-star-fill",
    "items": [
      {"label": "courses", "url": "/", "icon":  "pi pi-search"},
      {"label": "for_course_owners", "url": "/demo", "icon":  "pi pi-briefcase"},
      {"label": "contacts", "url": "/contacts", "icon":  "pi pi-telegram"},
      {"label": "login", "url": "/login", "icon":  "pi pi-lock-open"}
    ]
  }
]
export default course1Menu